<div class="card-doacao" (click)="onRowClick(pagamento)">
  <div class="code">
    <span>Código</span>
    <h4>{{ codigo }}</h4>
  </div>

  <article class="tittle">
    <span>Doador</span>
    <h4>{{ titulo }}</h4>
  </article>

  <article class="reference">
    <span>Referência</span>
    <h4>{{ referencia || "Pendente" }}</h4>
  </article>

  <article>
    <span>Valor Total</span>
    <h4>{{ valorDoado | money }} Kz</h4>
  </article>

  <article>
    <span>Canal</span>
    <h4>{{ canal || "Pendente" }}</h4>
  </article>

  <article>
    <span>Data</span>
    <h4>{{ data }}</h4>
  </article>

  <div class="item-icon">
    <span>Estado</span>
    <p-tag [severity]="getSeverity(estado)" [value]="estado"></p-tag>
  </div>

  <div
    class="flex justify-center items-center"
    (click)="$event.stopPropagation()"
  >
    <p-menu
      #menuRef
      [model]="getMenuActions(pagamento)"
      [popup]="true"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="10000"
    >
    </p-menu>

    <p-button
      icon="pi pi-ellipsis-v"
      severity="secondary"
      (click)="openMenu($event, menuRef)"
    >
    </p-button>
  </div>
</div>
